var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "date-field-wrapper",
      class: _vm.opened ? "calendar-opened" : "",
    },
    [
      _vm._t("default", null, null, _vm.bindings),
      _vm._v(" "),
      _vm.opened
        ? _c("calendar-input", {
            attrs: {
              "start-date": _vm.startDate,
              "end-date": _vm.endDate,
              "disabled-dates": _vm.disabledDates,
              "disabled-week-dates": _vm.disabledWeekDates,
              lang: _vm.lang,
              "outer-activator": _vm.target,
            },
            on: {
              close: function ($event) {
                _vm.opened = false
              },
            },
            model: {
              value: _vm.date,
              callback: function ($$v) {
                _vm.date = $$v
              },
              expression: "date",
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }